class StorageUtils {
  static storeObjectToSession(key, obj) {
    if (key && obj) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(obj));
      } catch (e) {}
    }
  }

  static retrieveObjectFromSession(key) {
    if (key) {
      try {
        return JSON.parse(window.sessionStorage.getItem(key));
      } catch (e) {}
    }
  }

  static storeStringToSession(key, str) {
    if (key && str) {
      try {
        window.sessionStorage.setItem(key, str);
      } catch (e) {}
    }
  }

  static retrieveStringFromSession(key) {
    if (key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (e) {}
    }
  }

  static removeFromSession(key) {
    if (key) {
      window.sessionStorage.removeItem(key);
    }
  }

  static clearSession() {
    window.sessionStorage.clear();
  }

  static storeObjectToLocal(key, obj) {
    if (key && obj) {
      try {
        window.localStorage.setItem(key, JSON.stringify(obj));
      } catch (e) {}
    }
  }
  
  static retrieveObjectFromLocal(key) {
    if (key) {
      try {
        return JSON.parse(window.localStorage.getItem(key));
      } catch (e) {}
    }
  }

  static storeStringToLocal(key, str) {
    if (key && str) {
      try {
        window.localStorage.setItem(key, str);
      } catch (e) {}
    }
  }

  static retrieveStringFromLocal(key) {
    if (key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {}
    }
  }

  static removeFromLocal(key) {
    if (key) {
      window.localStorage.removeItem(key);
    }
  }

  static clearLocal() {
    window.localStorage.clear();
  }
}

export default StorageUtils;


// WEBPACK FOOTER //
// ./src/utils/StorageUtils.js